/**
 * Anonymous action counts through Umami (the script in index.html; no cookies).
 * Only what was done and in which tools travels — never anything typed or
 * produced. Events: open-in, copy, clip, pin, share-link, archive-open, install.
 * Without the script (blocked, offline, Node tests) nothing happens.
 */

/** @param {string} event @param {Record<string, string | boolean>} [data] tool ids and flags only */
export function track(event, data) {
  try {
    window.umami?.track(event, data);
  } catch {
    /* analytics must never break the app */
  }
}
